import { FC, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'

import {
	Button,
	Container,
	Form,
	SpaceBetween,
	Textarea
} from '@cloudscape-design/components'

import { MicroserviceRejectionRequest } from '../../../types/microservices'
import useRejectMicroservice from '../../../hooks/mutate/useRejectMicroservice'
import { useNavigate } from 'react-router-dom'

interface RejectionFormProps {
	thisMicroserviceID: string
	shouldShowRejectionForm: (shouldShow: boolean) => void
}

const RejectionForm: FC<RejectionFormProps> = ({
	thisMicroserviceID,
	shouldShowRejectionForm
}) => {
	const { authState } = useOktaAuth()
	const navigate = useNavigate()
	const thisUserEmail = authState?.idToken?.claims.email as string

	const [commentText, setCommentText] = useState('')

	const { mutate: rejectMicroservice, isLoading } =
		useRejectMicroservice(thisMicroserviceID)

	const handleReject = () => {
		const rejectionRequest: MicroserviceRejectionRequest = {
			action: 'REJECT',
			microserviceID: thisMicroserviceID,
			commenterID: thisUserEmail,
			comment: commentText
		}

		rejectMicroservice(rejectionRequest, {
			onSuccess: () => {
				shouldShowRejectionForm(false)
				setCommentText('')
				window.location.reload()
				navigate(`/microservices/${thisMicroserviceID}`)
			}
		})
	}

	return (
		<Form
			actions={
				<SpaceBetween direction="horizontal" size="xs">
					<Button variant="link" onClick={() => shouldShowRejectionForm(false)}>
						Cancel
					</Button>
					<Button variant="primary" loading={isLoading} onClick={handleReject}>
						Reject
					</Button>
				</SpaceBetween>
			}
		>
			<Container>
				<SpaceBetween direction="vertical" size="l">
					<Textarea
						onChange={({ detail }) => setCommentText(detail.value)}
						value={commentText}
						placeholder="Reason for rejection"
					/>
				</SpaceBetween>
			</Container>
		</Form>
	)
}

export default RejectionForm
